/* @flow */
// typecheck: ignore file
import { dispatcher, reduxDispatcher } from 'lib/Dispatcher';
import { ActionTypes } from 'payments/constants/ActivityConstants.js';
import Activity from 'entities/Activity';
import * as actions from 'payments/reducers/Activities';
import Activities from 'collections/Activities';
import Transactions from 'collections/Transactions';
import API from 'lib/RemindAPI';

import type { ActivityCreateParams, ActivityEditParams } from 'payments/constants/ActivityTypes';

const ActivityActions = {
  create(params: ActivityCreateParams) {
    return Activity.create(params).then(activity => {
      dispatcher.dispatch({
        type: ActionTypes.CREATE_ACTIVITY,
        activity,
      });

      return activity;
    });
  },

  edit(params: ActivityEditParams) {
    return Activity.edit(params).then(editedActivity => {
      dispatcher.dispatch({
        type: ActionTypes.EDIT_ACTIVITY,
        activity: editedActivity,
      });

      return editedActivity;
    });
  },

  close(activityToClose: Activity) {
    return activityToClose.close().then(activity => {
      dispatcher.dispatch({
        type: ActionTypes.CLOSE_ACTIVITY,
        activity,
      });
      return activity;
    });
  },

  load() {
    return Activities.load().then(activities => {
      // flux
      dispatcher.dispatch({
        type: ActionTypes.LOAD_ACTIVITIES,
        activities,
      });

      // activity store is still flux, dispatch redux action too.
      // activityRecipient redux store listens to this.
      reduxDispatcher.dispatch(
        actions.loadActivitiesSuccess(activities)
      );
    });
  },

  loadByUuid(uuid: string) {
    return Activity.findByUuid(uuid).then(activity => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_ACTIVITY,
        activity,
      });
      return activity;
    });
  },

  getTransactions(activityId: string) {
    return API.request(`/activities/${activityId}/transactions`, 'GET').then((response) => {
      const transactions = Transactions.fromJSON(response['transactions']);

      dispatcher.dispatch({
        type: ActionTypes.GET_TRANSACTIONS,
        transactions,
        activityId,
      });

      return transactions;
    });
  },
};

export default ActivityActions;



// WEBPACK FOOTER //
// ./src/payments/actions/ActivityActions.js